module.exports = __webpack_public_path__ + "media/scholarship_winners/megan-h-502ce268.png";